import type { OsobyCertifikatHistorieDto } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import type { Optional } from '@gov-nx/core/types';
import { getEntries } from '@gov-nx/core/types';
import { PageCode } from '@gov-nx/module/page';
import { Button, DataTable, Dialog, LayoutGap } from '@gov-nx/ui/web';
import {
	getFormattedPublisher,
	toDateReadable,
	toDateTimeReadable,
	useBoolean,
} from '@gov-nx/utils/common';

const Table = ({ rows }: { rows: Record<string, Optional<string>> }) => (
	<DataTable
		responsive
		customClasses="text-body-s!">
		<tbody>
			{getEntries(rows).map(([key, value]) => (
				<tr key={key}>
					<td className="sm:w-1/2">{key}</td>
					<td className="sm:w-1/2">
						<strong>{value ?? '-'}</strong>
					</td>
				</tr>
			))}
		</tbody>
	</DataTable>
);

interface Props {
	history: OsobyCertifikatHistorieDto[];
}

export const HistoryModal = ({ history }: Props) => {
	const code = PageCode['profil-certifikaty'];
	const { t } = useLocale(code);
	const isOpen = useBoolean(false);

	return (
		<>
			<Button
				onClick={isOpen.setTrue}
				nativeType="submit"
				color="primary"
				isDisabled={history.length === 0}
				size="l"
				type="outlined"
				isExpandedMobile
				aria-label={t('akce.zobraz-historii')}>
				{t('akce.zobraz-historii')}
			</Button>
			<Dialog
				isOpen={isOpen.isTrue}
				onClose={isOpen.setFalse}
				title={<h3>{t('certifikaty.historie-certifikatu.modal-titulek')}</h3>}>
				<LayoutGap gap="m">
					{history.map((item) => (
						<LayoutGap
							gap="s"
							key={`${item.serioveCislo}-${item.datumZmeny}-${item.platnostOd}`}>
							{item.datumZmeny ? (
								<p className="text-(--text-secondary)!">
									{toDateTimeReadable(item.datumZmeny)}
								</p>
							) : null}
							<Table
								rows={{
									[t('certifikaty.historie-certifikatu.vydavatel')]:
										item.vydavatel ? getFormattedPublisher(item.vydavatel) : '',
									[t('certifikaty.historie-certifikatu.seriove-cislo')]:
										item.serioveCislo,
									[t('certifikaty.historie-certifikatu.platnost-do')]:
										item.platnostDo
											? toDateReadable(item.platnostDo)
											: undefined,
									[t('certifikaty.historie-certifikatu.typ-zmeny')]:
										item.operace
											? t(
													`certifikaty.historie-certifikatu.operace.${item.operace}`
												)
											: '-',
								}}
							/>
						</LayoutGap>
					))}
				</LayoutGap>
			</Dialog>
		</>
	);
};
